import React from "react";
import HeroSection from "./HeroSection";
import TrustBar from "./TrustBar";
import WhatWeDo from "./WhatWeDo";
import FeaturesGrid from "./FeaturesGrid";
import WhyDigiryte from "./WhyDigiryte";
import HowWeWork from "./HowWeWork";
import OutcomePackages from "./OutcomePackages";
import CaseStudies from "./CaseStudies";
import FAQSection from "./FAQSection";
import CTAFooter from "./CTAFooter";
import StackSection from "./StackSection";
import Family from "../AboutUsPage/Family";

const NewHomePage = () => {
  return (
    <div
      className="new-homepage"
      // style={{
      //   fontFamily:
      //     "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      // }}
    >
      {/* Hero is the base card — no stacking frame */}
      <StackSection index={0}>
        <HeroSection />
      </StackSection>

      <StackSection index={2}>
        <TrustBar />
      </StackSection>

      <WhatWeDo />

      <Family variant="practices" />

      <StackSection index={3}>
        <FeaturesGrid />
      </StackSection>

      <StackSection index={4}>
        <WhyDigiryte />
      </StackSection>

      <StackSection index={5}>
        <HowWeWork />
      </StackSection>

      <OutcomePackages />

      <StackSection index={6}>
        <CaseStudies />
      </StackSection>

      <StackSection index={7}>
        <FAQSection />
      </StackSection>

      <StackSection index={8}>
        <CTAFooter />
      </StackSection>
    </div>
  );
};

export default NewHomePage;
